import { API_BASE_URL } from './apiConfig';

export const handleSubmit = async (e, selectedDatFile, selectedHexFile, newVersion, onUploadSuccess) => {
  e.preventDefault();
  if (!selectedDatFile || !selectedHexFile || !newVersion) {
    console.log('Please select both files and enter a version number.');
    return { success: false, error: 'Please select both files and enter a version number.' };
  }

  try {
    // Step 1: Check if version exists
    const versionCheckResponse = await fetch(`${API_BASE_URL}/ota/check-version?version=${newVersion}`);
    if (!versionCheckResponse.ok) {
      throw new Error('Version check failed');
    }
    const versionCheckData = await versionCheckResponse.json();
    
    if (versionCheckData.result) {
      return { success: false, error: `Version ${newVersion} already exists` };
    }

    // Step 2: Upload .dat file
    const formData1 = new FormData();
    formData1.append('file', selectedDatFile);
    formData1.append('file_version', newVersion);
    const response1 = await fetch(`${API_BASE_URL}/ota/upload-file`, {
      method: 'PUT',
      body: formData1,
    });

    if (!response1.ok) {
      throw new Error('DAT file upload failed');
    }

    // Step 3: Upload .hex file
    const formData2 = new FormData();
    formData2.append('file', selectedHexFile);
    formData2.append('file_version', newVersion);
    const response2 = await fetch(`${API_BASE_URL}/ota/upload-file`, {
      method: 'PUT',
      body: formData2,
    });

    if (!response2.ok) {
      throw new Error('HEX file upload failed');
    }

    console.log('Files uploaded successfully');
    if (onUploadSuccess) {
      onUploadSuccess();
    }
    return { success: true };
  } catch (error) {
    console.error('Error uploading files:', error);
    return { success: false, error: error.message };
  }
};